import { FetchError, toSaveErrorMessage } from 'prove-common'

// Shared delete hooks return the OpenAPI envelope instead of rejecting it.
export function requireSuccessfulResponse(result: unknown): void {
  if (!result || typeof result !== 'object') return
  const response = 'response' in result ? result.response : undefined
  const error = 'error' in result ? result.error : undefined
  if (response instanceof Response && !response.ok) {
    throw new FetchError('Forespørselen ble avvist.', response.status)
  }
  if (error != null) throw error
}

export function referenceErrorMessage(
  error: unknown,
  deleting = false
): string {
  const status =
    error && typeof error === 'object' && 'status' in error
      ? Number(error.status)
      : undefined
  if (!deleting)
    return toSaveErrorMessage(
      error instanceof FetchError || status === undefined
        ? error
        : new FetchError('Forespørselen ble avvist.', status),
      'lagre oppføringen',
      {
        conflictMessage:
          'Kunne ikke lagre oppføringen. Navnet eller koden kan allerede være i bruk. Kopier endringene dine og last siden på nytt for å se oppdaterte opplysninger. Kontroller navn og kode før du lagrer på nytt.'
      }
    )
  if (status === 409) {
    return 'Kan ikke slettes fordi oppføringen er i bruk. Fjern tilknytningene før du prøver igjen.'
  }
  if (status === 412) {
    return 'Oppføringen er endret av en annen bruker. Utkastet ditt er beholdt. Kopier endringene, lukk dialogen og last siden på nytt for å hente siste versjon.'
  }
  if (status === 403)
    return 'Du har ikke tilgang til å utføre denne handlingen.'
  if (status === 404)
    return 'Oppføringen finnes ikke lenger. Lukk dialogen og oppdater listen.'
  return 'Kunne ikke slette. Ingenting er bekreftet slettet. Prøv igjen.'
}
